<template>
    <el-dialog
        title="手工发车异常备注登记"
        width="400px"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'abnormalRemarkDialog'"
        >
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="发车异常备注：" prop="departExceptionRemarks">
                <otpSelect
                    :optionNum="'DISPATCH_ABNORMAL_REASON'"
                    @getSelectValue="getSelectValue"
                    :mValue="form.departExceptionRemarks"
                    placeholder="请选择发车原因"
                    :prop="'departExceptionRemarks'"
                >
                </otpSelect>
            </el-form-item>
            <el-form-item label="其他：" prop="departExceptionInformation" v-if="form.departExceptionRemarks === '5'">
                <el-input
                    v-model.trim="form.departExceptionInformation"
                    type="text"
                    placeholder="请维护PC端发车异常原因"
                    maxlength="64"
                    show-word-limit
                    clearable>
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="btnLoading">确 认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import otpSelect from '@/components/lots/otpSelect';
import { addExceptionRemarks } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    name: 'DispatchAbnormalReason',
    components: { otpSelect },
    props: {
        componentsData: {
            type: [Object, Array]
        }
    },
    data () {
        return {
            btnLoading: false,
            form: {
                departExceptionRemarks: '',
                departExceptionInformation: ''
            },
            rules: {
                departExceptionRemarks: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                return callback(new Error('异常发车原因必选'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                departExceptionInformation: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value && +this.form.departExceptionRemarks === 5) {
                                return callback(new Error('必填备注原因,填写限制64个字。'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    methods: {
        /**
         * @description: 高级下拉选中的回调
         * @param {*} data 选中的数据
         * @return {*}
         */
        getSelectValue (data) {
            this.form.departExceptionRemarks = data.departExceptionRemarks || '';
            // 异常原因不为其他时，备注输入框清空
            if (+this.form.departExceptionRemarks !== 5) {
                this.form.departExceptionInformation = '';
            }
        },
        /**
         * @description 关闭
         */
        beforeClose () {
            // this.$emit('update:isShowRemarkDialog', false);
            this.$emit('closeRemarkDialog');
        },
        /**
         * @description 提交
         */
        handleSubmit () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const params = this.getParams();
                    const isValidated = this.validateParams(params.dispatchNoList);
                    if (!isValidated) return;
                    this.btnLoading = true;
                    addExceptionRemarks(params).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('保存成功');
                            this.btnLoading = false;
                            this.beforeClose();
                            this.handleDepartType();
                        }
                    }).finally(() => {
                        this.btnLoading = false;
                    });
                };
            });
        },
        /**
         * @description 组装提交参数
         */
        getParams () {
            let dispatchNoList;
            if (Array.isArray(this.componentsData)) {
                dispatchNoList = this.componentsData.map(item => item.dispatchNo);
            } else {
                dispatchNoList = [this.componentsData.dispatchNo];
            }
            const params = {
                dispatchNoList: dispatchNoList,
                departExceptionRemarks: this.form.departExceptionRemarks,
                departExceptionInformation: this.form.departExceptionInformation
            };
            return params;
        },
        /**
         * @description 校验发车单号是否为空
         */
        validateParams (data) {
            if (!data.length || data.every(item => !item)) {
                this.$message.warning('发车单号不能为空');
                return false;
            }
            return true;
        },
        /**
         * @description 保存成功之后触发事件
         */
        handleDepartType () {
            if (Array.isArray(this.componentsData)) {
                this.$emit('handleBatchDepart', true);
            } else {
                this.$emit('depart', this.componentsData, true);
            }
        }
    }
};
</script>

<style lang="less" scoped>

</style>
